// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';
import {EquipmentItem} from './equipment-item';

export const EquipmentDetails = t.struct({
    equipmentList: t.list(EquipmentItem),
    isEquipmentLoading: t.Boolean,
    showErrorMessage: t.Boolean,
    warning: t.String
}, {
    defaultProps: {
        equipmentList: [],
        isEquipmentLoading: true,
        showErrorMessage: false,
        warning: ''
    },
    name: 'EquipmentDetails',
    strict: true
});
